import api from './api';
// 获得首页banner图
export function bannerList(param) {
  return api.post('/banner/getBannerList', param, true, false);
}

// 推荐的平台
export function pingtaiList(param) {
  return api.post('/system/listsystem', param, true, false);
}

// 股东单位
export function homeholder(param) {
  return api.post('/master/pagemaster.go', param, true, false);
}

// 首页宣传视频
export function homeMovie(param) {
  return api.post('/movie/indexMovie', param, true, false);
}
// 首页简介
export function homeSummary(param) {
  return api.post('/company/companysm', param, true, false);
}



// WEBPACK FOOTER //
// ./src/api/frontApi/frontHome.js